<template>
  <HeaderContent title="Room" />
  <ActionContent
    ctaText="Add Room"
    @action="showModal"
    v-model:start-date="startDate"
    v-model:end-date="endDate"
    @showFilter="modalFilter = !modalFilter"
    :filterDate="true"
    @search-query="searchData"
  />
  <RoomStatistics title="Room Statistics" :data="statistics" />
  <RoomStatus title="Room Status" :data="statisticsStatus" />
  <RoomForm
    :modal="modal"
    :roomData="room"
    @update:modal="updateModal"
    @addOrUpdate="getAll"
  />
  <RoomFilter
    :modalFilter="modalFilter"
    @update:modalFilter="modalFilter = $event"
    @filter-data="filterData"
  />
  <RoomConfirm
    title="Confirmation"
    :uuid="roomUuid"
    :modalConfirm="modalConfirm"
    v-model="modalConfirm"
    @confirmed="deleteData(roomUuid)"
  >
    <template #text>Are you sure to DELETE this data ? <br> 
      This may cause effect to reservation data !</template>
  </RoomConfirm>
  <RoomDataTable
    :data="rooms"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  />
  <FormMaintenance
    v-if="modalMaintenance"
    v-model="modalMaintenance"
    :data="dataMaintenance"
  ></FormMaintenance>

</template>
<script>
import { ref, inject, onMounted } from "vue";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import RoomForm from "./RoomForm.vue";
import RoomFilter from "./RoomFilter.vue";
//import RoomStatistics from "@/components/StatisticRoom.vue";
import RoomStatistics from "@/components/StatisticData.vue";
import RoomStatus from "@/components/RoomStatus.vue";
import RoomConfirm from "@/components/ModalDialog.vue";
import RoomDataTable from "@/components/DataTable.vue";
import iconDeluxe from '../../../public/icons/business-value.svg';
import iconSuperDeluxe from '../../../public/icons/dorm-room.svg';
import iconStudio from '../../../public/icons/space-station-moon.svg';
import iconHoneymoon from '../../../public/icons/rings-wedding.svg';
import iconFamily from '../../../public/icons/family-pants.svg';
import iconDefault from '../../../public/icons/home-location.svg';
import iconAvailable from '../../../public/icons/octagon-check.svg';
import iconReserved from "../../../public/icons/reservation-table.svg";
import iconDirty from "../../../public/icons/sweep.svg";
import iconInhouse from "../../../public/icons/person-shelter.svg";
import iconIncleaning from "../../../public/icons/sparkles.svg";
import iconMaintenance from "../../../public/icons/wrench-simple.svg";
import FormMaintenance from "./FormMaintenance/FormMaintenance.vue";

export default {
  components: {
    HeaderContent,
    ActionContent,
    RoomForm,
    RoomFilter,
    RoomConfirm,
    RoomStatistics,
    RoomStatus,
    RoomDataTable,
    FormMaintenance,
  },
  setup() {
    const repositories = inject("repositories");
    const roomRepository = repositories ? repositories.rooms : null;
    const roomCategoryRepository = repositories
      ? repositories.roomCategory
      : null;
    const modal = ref(false);
    const modalFilter = ref(false);
    const modalConfirm = ref(false);
    const roomUuid = ref(null);
    const modalMaintenance = ref(false);
    const dataMaintenance = ref({});
    const room = ref({});
    const rooms = ref([]);

    const headers = ref([
      {
        key: "room_category",
        label: "Type",
        sortable: true,
        tdClass: "text-center w-25 px-5",
      },
      {
        key: "code",
        label: "Number",
        sortable: true,
        tdClass: "text-left",
        thClass: "text-left",
        // tdClass: "text-center",
      },
      {
        key: "status_room",
        label: "Status",
        sortable: true,
        tdClass: "text-center",
      },
      {
        key: "action",
        label: "Actions",
      },
    ]);

    const customActions = ref([
      {
        label: "Update",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
          getById(item.uuid);
        },
      },
      {
        label: "Set Maintenance",
        variant: "warning",
        icon: "fas fa-wrench",
        action: (item) => {
          console.log("data maintenance", item);
          dataMaintenance.value = { item };
          modalMaintenance.value = true;
        },
      },
      {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
          showConfirmModal(item.uuid);
        },
      },
    ]);

    const date = new Date();
    const getStartDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-01`;
    const getCurrentDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

    const startDate = ref(getStartDate);
    const endDate = ref(getCurrentDate);

    const statistics = ref([]);
    const statisticsStatus = ref([]);

    const iconMap = {
      "Deluxe": iconDeluxe,
      "Super Deluxe": iconSuperDeluxe,
      "Studio": iconStudio,
      "Honeymoon Suite": iconHoneymoon,
      "Family": iconFamily,
    };

    const iconStatusMap = {
      available: iconAvailable,
      reserved: iconReserved,
      in_house: iconInhouse,
      dirty: iconDirty,
      in_cleaning: iconIncleaning,
      under_maintenance: iconMaintenance,
      // ...kategori lainnya
    };  

    const colorMap = {
      available: 'success',
      reserved: 'primary',
      in_house: 'warning',
      dirty: 'dark',
      in_cleaning: 'secondary',
      under_maintenance: 'danger',
      // ...kategori lainnya
    };

    const defaultIcon = iconDefault;

    const getListRoomCategory = async () => {
      try {
        const response = await roomCategoryRepository.getAll();
        statistics.value = response.data.data.map((category) => ({
          label: "Total",
          key: category.name,
          value: category.rooms_count,
          //color: category.color,
          icon: iconMap[category.name] || defaultIcon,
        }));
      } catch (error) {
        console.error(error);
      }
    };

    function capitalizeWords(str) {
      return str.replace(/_/g, ' ')
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
    }
    const generateRoomStatusStatistics = () => {
      const statusCounts = {
        available: 0,
        reserved: 0,
        in_house: 0,
        dirty: 0,
        in_cleaning: 0,
        under_maintenance: 0,
      };

      rooms.value.forEach((room) => {
        const status = room.status?.toLowerCase();
        if (statusCounts[status] !== undefined) {
          statusCounts[status]++;
        }
      });

      statisticsStatus.value = Object.entries(statusCounts).map(([key, value]) => ({
        //label: key.replace(/_/g, ' ').toUpperCase(), // jadi "IN HOUSE"
        label: capitalizeWords(key),
        key,
        value,
        icon: iconStatusMap[key] || defaultIcon,
        color: colorMap[key] || 'secondary',
      }));
      console.log('statisticsStatus:', statisticsStatus.value);
    };

    const params = ref({
      search: "",
    });

    const getAll = async (params) => {
      await roomRepository
        .getAll(params)
        .then((res) => {
          // console.log('res:', res); // ← Lihat keseluruhan respons
          // console.log('res.data:', res.data);               // full data
          // console.log('res.data.data:', res.data.data);     // data array    
          // console.log('rooms.value:', rooms.value);

          rooms.value = res.data.data;
          statistics.value = [];
          getListRoomCategory();
          generateRoomStatusStatistics(); 
        })
        .catch((err) => {
          console.error('Gagal ambil data room:',err);
        });
    };

    const getById = async (uuid) => {
      await roomRepository
        .getById(uuid)
        .then((res) => {
          room.value = res.data.data;
          room.value.room_category_uuid = res.data.data.room_category.uuid;
          // console.log(room.value.room_category_uuid)
          modal.value = true;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const updateModal = (newValue) => {
      modal.value = newValue;
      room.value = {};
      room.value = {};
    };

    const showModal = () => {
      modal.value = true;
    };

    const showConfirmModal = async (uuid) => {
      modalConfirm.value = true;
      roomUuid.value = uuid;
      console.log(roomUuid.value);
    };

    const deleteData = async () => {
      await roomRepository
        .delete(roomUuid.value)
        .then(() => {
          modalConfirm.value = false;
          getAll();
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const searchData = async (keyword) => {
      await roomRepository
        .search(keyword)
        .then((res) => {
          rooms.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const filterData = async (category, status) => {
      await roomRepository
        .filter(category, status)
        .then((res) => {
          rooms.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    onMounted(() => {
      getAll();
    });

    return {
      showModal,
      updateModal,
      startDate,
      endDate,
      getAll,
      getById,
      deleteData,
      params,
      rooms,
      room,
      roomUuid,
      headers,
      modal,
      modalFilter,
      modalConfirm,
      customActions,
      statistics,
      statisticsStatus,
      searchData,
      filterData,
      modalMaintenance,
      dataMaintenance,
    };
  },
};
</script>

<style></style>
